import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import MainAppBar from '../../containers/main-appbar';
import MainContent from '../../containers/main-content';
import MainDrawer from '../../containers/main-drawer';
import { withDefaultStyles } from '../../utils/material-ui/hoc';
import Content from './containers/content';

class TenantsMain extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <MainAppBar title='All Tenants' />
        <MainDrawer selectedMenu='tenants'/>
        <MainContent>
          <Content />
        </MainContent>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(TenantsMain)));



// WEBPACK FOOTER //
// ./src/sub-projects/tenants/main.tsx